import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Card, CardHeader, Divider, CardContent, TextField, TableContainer, Button, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Container, Backdrop, CircularProgress, Snackbar, TablePagination, Box, Checkbox, Menu, MenuItem, Autocomplete, OutlinedInput, InputAdornment, ThemeProvider, Alert as MuiAlert } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import axios from 'src/utils/axios';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import Page from 'src/components/Page';
import Alert from 'src/components/Alert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import beratSvg from 'src/assets/images/img/Berat.png';
import ArcelikImg from 'src/assets/images/img/1.png';
import BekoImg from 'src/assets/images/img/2.png';
import PrintIcon from '@mui/icons-material/Print';
import SearchIcon from '@mui/icons-material/Search';
import html2canvas from 'html2canvas';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { getUser } from 'src/utils/Common';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { DataGrid } from '@mui/x-data-grid';
import { trTR } from '@mui/x-data-grid/locales';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Chip from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import PendingIcon from '@mui/icons-material/Pending';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BeratDocumentUploadDialog from './YSBeratKanit';
import BeratHesaplaDialog from './YSBeratHesapla';
import ReferansTarihiDialog from './YSReferansGir';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { EditCalendar } from '@mui/icons-material';
import { theme as appTheme } from 'src/modules/theme';

const theme2 = appTheme;


const styles = {
    root: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none',
        },
    },
    rootlist: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    }),
    rootlistsag: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    }),

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    container: {
        maxHeight: '100%',
        maxWidth: '100%',
        minWidth: '100%'
    },
    container1: {
        maxHeight: 630,
        maxWidth: '100%',
        minWidth: '100%'
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    closeButton: (theme) => ({
        position: 'absolute',
        right: theme.spacing(0),
        top: theme.spacing(-1),
        color: theme.palette.grey[500],
    }),
    formControl: (theme) => ({
        margin: theme.spacing(3)
    }),
    cardscontent3: {
        minHeight: 50
    },
    cardscontent: {
        minHeight: 120
    },
    cardscontent2: {
        height: 600
    },
    spanText: {
        lineHeight: 2,
        fontFamily: 'Roboto',
        fontSize: 14
    },
    textInput: {
        border: 'none',
        borderBottom: '1px solid #FF9800',
        padding: '2px 5px',
        outline: 'none',
        fontWeight: 'bold',
    },
    textInput2: {
        border: 'none',
        borderBottom: '1px solid #FF9800',
        padding: '2px 5px',
        outline: 'none',

    },
    responsiveContainer: (theme) => ({
        [theme.breakpoints.between("md", "lg")]: {
            maxHeight: "70vh",
            overflowX: 'hidden',
            overflowY: 'scroll'
        },
        [theme.breakpoints.down("sm")]: {
            maxHeight: "60vh",
            overflow: 'scroll'
        }
    }),
    dialogPaper: {
        minHeight: '80vh',
        maxHeight: '80vh',
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '10px',
        borderRadius: 10,
    },
};


function isOverflown(element) {
    return (
        element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth
    );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
    const { width, value } = props;
    const wrapper = React.useRef(null);
    const cellDiv = React.useRef(null);
    const cellValue = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showFullCell, setShowFullCell] = React.useState(false);
    const [showPopper, setShowPopper] = React.useState(false);

    const handleMouseEnter = () => {
        const isCurrentlyOverflown = isOverflown(cellValue.current);
        setShowPopper(isCurrentlyOverflown);
        setAnchorEl(cellDiv.current);
        setShowFullCell(true);
    };

    const handleMouseLeave = () => {
        setShowFullCell(false);
    };

    React.useEffect(() => {
        if (!showFullCell) {
            return undefined;
        }

        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
                setShowFullCell(false);
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowFullCell, showFullCell]);

    return (
        <Box
            ref={wrapper}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{
                alignItems: 'center',
                lineHeight: '24px',
                width: '100%',
                height: '100%',
                position: 'relative',
                display: 'flex',
            }}
        >
            <Box
                ref={cellDiv}
                sx={{
                    height: '100%',
                    width,
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                }}
            />
            <Box
                ref={cellValue}
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
                {value}
            </Box>
            {showPopper && (
                <Popper
                    open={showFullCell && anchorEl !== null}
                    anchorEl={anchorEl}
                    style={{ width, marginLeft: -17 }}
                >
                    <Paper
                        elevation={1}
                        style={{ minHeight: wrapper.current.offsetHeight - 3 }}
                    >
                        <Typography variant="body2" style={{ padding: 8 }}>
                            {value}
                        </Typography>
                    </Paper>
                </Popper>
            )}
        </Box>
    );
});

GridCellExpand.propTypes = {
    value: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
};

function renderCellExpand(params) {
    return (
        <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
    );
}

renderCellExpand.propTypes = {
    /**
     * The column of the row that the current cell belongs to.
     */
    colDef: PropTypes.object.isRequired,
    /**
     * The cell value.
     * If the column has `valueGetter`, use `params.row` to directly access the fields.
     */
    value: PropTypes.string,
};

const YSBeratManagement = () => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const avatar = 'src/assets/images/avatars/avatar_1.png';
    const theme = useTheme();
    const [beratData, setBeratData] = useState([]);
    const [selectedServiceCode, setSelectedServiceCode] = useState('');
    const [selectedServiceName, setSelectedServiceName] = useState('');
    const [openBeratConfirm, setOpenBeratConfirm] = useState(false);
    const [beratComment, setBeratComment] = useState('');
    const [required, setRequired] = useState(false);
    const [beratCommentError, setBeratCommentError] = useState('');
    const [operationIndex, setOperationIndex] = useState(0);
    const [selectedEmployeeBerat, setSelectedEmployeeBerat] = useState({});
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState('default');
    const [responseMessage, setresponseMessage] = useState('');
    const [openBeratPreview, setOpenBeratPreview] = useState(false);
    const [beratYili, setBeratYili] = useState(0);
    const svgRef = useRef(null);
    const [textLength, setTextLength] = useState(0);
    const [textStyle1X, setTextStyle1X] = useState(0);
    const svgWidth = 1000;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [tabValue, setTabValue] = useState(0);
    const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
    const [BirimData, setBirimData] = React.useState([]);
    const [BirimDataForConfirm, setBirimDataForConfirm] = React.useState([]);
    const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
    const [selectedbolgeAdiKoduFormForConfirm, setSelectedbolgeAdiKoduFormForConfirm] = React.useState([]);
    const [SelectedBirim, setSelectedBirim] = React.useState([]);
    const [SelectedBirimForConfirm, setSelectedBirimForConfirm] = React.useState([]);
    const SessionUser = getUser();
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
    const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;
    const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };
    const [catalogData, setCatalogData] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [openBeratUpload, setOpenBeratUpload] = useState(false);
    const [openBeratHesapla, setOpenBeratHesapla] = useState(false);
    const [openReferansGir, setOpenReferansGir] = useState(false);
    const [durumFilter, setDurumFilter] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);


    useEffect(() => {
        document.title = 'YS Berat Yönetimi';
    }, []);

    const textStyle1 = {
        fontSize: '70px',
        fontFamily: 'Poppins-Regular_2h',
        fill: '#B27409', // Use 'fill' instead of 'color' for SVG text elements
    };

    const textStyle2 = {
        fontSize: '27px',
        fontFamily: 'Poppins-Regular_2h',
        fill: 'rgba(0, 0, 0, 0.8)',
    };

    const textStyle3 = {
        fontSize: '31px',
        fontFamily: 'Poppins-Regular_2h',
        fill: 'rgba(178, 116, 9, 0.8)',
    };

    const containerStyle = {
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: 'white',
        width: '1286px',
        height: '909px',
    };

    const InputStyle = {
        "& label.Mui-focused": {
            color: "green"
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "green"
            }
        }
    }


    useEffect(() => {
        setLoading(true);
        getBolgeAdiKoduData();
        setLoading(false);
    }, []);

    useEffect(() => {
        const tmpTextLength = selectedServiceCode.length + selectedServiceName.length + 1;
        setTextLength(tmpTextLength);
        setTextStyle1X((svgWidth - (tmpTextLength * 9)) / 2);
    }, [selectedServiceCode, selectedServiceName]);


    const handleDurumFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleDurumFilterSelect = (value) => {
        setDurumFilter(value);
        setAnchorEl(null);
    };

    const durumOptions = [
        { value: null, label: 'Tümü' },
        { value: 0, label: 'Onay bekliyor' },
        { value: 1, label: 'Onaylandı' },
        { value: 2, label: 'Reddedildi' }
    ];
    const getBeratConfirmData = () => {
        if (!selectedbolgeAdiKoduFormForConfirm || selectedbolgeAdiKoduFormForConfirm.length < 1) {
            setresponseMessage('Lütfen bölge seçimi yapınız!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setLoading(true);
        const birimKoduQuery = !SelectedBirimForConfirm || SelectedBirimForConfirm.length < 1 || SelectedBirimForConfirm.find((x) => x.BirimKodu == 0) ? '0'
            : SelectedBirimForConfirm?.map(x => x.BirimKodu).join("&BirimKodu=");
        const bolgeKoduQuery = !selectedbolgeAdiKoduFormForConfirm || selectedbolgeAdiKoduFormForConfirm.length < 1 || selectedbolgeAdiKoduFormForConfirm.find((x) => x.BirimKodu == 0) ? '0'
            : selectedbolgeAdiKoduFormForConfirm?.map(x => x.BirimKodu).join("&BolgeKodu=");
        axios.get(`GetServiceBeratConfirm?BolgeKodu=${bolgeKoduQuery}&BirimKodu=${birimKoduQuery}`).then((response) => {
            if (response.data.length > 0) {
                setBeratData(response.data);
                setLoading(false);
            } else {
                setBeratData([]);
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });
    }

    useEffect(() => {
        setRequired(false);
        setBeratCommentError('');
    }, [openBeratConfirm]);

    const handleBeratOperation = (operation) => {

        if (operation === 2 && beratComment.length <= 0) {
            setRequired(true);
            setBeratCommentError('Red işleminde yorum yazılması zorunludur!...');
            return;
        }

        setBeratConfirm(operation);

    }

    const setBeratConfirm = (operation) => {
        setLoading(true);
        const data = {
            "Year": selectedEmployeeBerat.BeratYili,
            "KulBirimKodu": selectedEmployeeBerat.ServisKodu,
            "OperationType": operation,
            "Comment": beratComment
        }


        const config = {
            headers: { 'Content-Type': 'application/json' }
        }

        axios.post('SetServiceBeratConfirm', data, config).then((response) => {
            if (response.data.ErrorCode === "0") {
                setresponseMessage(response.data.ErrorDescription);
                setUyariTip('success');
                setUyari(true);
                getBeratConfirmData();
                setOpenBeratConfirm(false);
                setLoading(false);
            }
            else {
                setresponseMessage(response.data.ErrorDescription);
                setUyariTip('error');
                setUyari(true);
                setLoading(false);
            }
        }).catch((error) => {
            setresponseMessage(error.message);
            setUyariTip('error');
            setUyari(true);
            setLoading(false);
        });

    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const handleDownloadImage = () => {
        const svgElement = svgRef.current;

        // SVG içerisindeki image etiketlerini resimlere dönüştürme
        const images = svgElement.getElementsByTagName('image');
        const imagePromises = [];

        for (let i = 0; i < images.length; i++) {
            const image = images[i];
            const imageUrl = image.getAttribute('href');
            const promise = new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    image.setAttribute('href', canvas.toDataURL());
                    resolve();
                };
                img.src = imageUrl;
            });
            imagePromises.push(promise);
        }

        // Tüm resimler işlendikten sonra SVG içeriğini resim olarak indirme
        Promise.all(imagePromises).then(() => {
            html2canvas(svgElement, { background: '#FFFFFF' }).then((canvas) => {
                const link = document.createElement('a');
                link.download = selectedServiceCode + ' ' + selectedServiceName + '.png';
                link.href = canvas.toDataURL();
                link.click();
            });
        });
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setPage(0); // Arama yapıldığında sayfa numarasını sıfırla
    };

    const filteredData = useMemo(() => {
        return beratData.filter(row => {
            var searchString = row.ServisKodu + ' ' + row.ServisAdi + ' ' + row.ServisUnvani;
            const searchMatch = searchString.toLowerCase().includes(searchTerm.toLowerCase());
            const durumMatch = durumFilter === null ? true : row.BeratDurum === durumFilter;
            return searchMatch && durumMatch;
        });
    }, [beratData, searchTerm, durumFilter]);


    const handleExportClick = () => {
        var exportData = [];
        beratData?.map((item) => {
            exportData.push({
                "Bölge Yöneticiliği": item.BolgeYoneticiligi,
                "Servis Kodu": item.ServisKodu,
                "Servis Adı": item.ServisAdi,
                "Servis Unvanı": item.ServisUnvani,
                "Hesap Tarihi": item.HesapTarihi,
                "Berat Referans Tarihi": item.ServisAcilisTarihi,
                "Berat Yılı": item.BeratYili,
                "Berat Sayacı (YIL)": item.BeratSayaci
            });
        }
        );
        ExcelFileCreator(exportData, "Berat Yönetimi");
    }

    const handleExportClickReport = () => {
        var exportDataReport = [];
        reportData.map((item) => {
            exportDataReport.push({
                "Bölge": item.BolgeYoneticiligi,
                "Servis Kodu": item.ServisKodu,
                "Servis Adı": item.ServisAdi,
                "Servis Unvanı": item.ServisUnvani,
                "Aktif/Pasif": item.Aktif,
                "Berat Referans Tarihi": item.ServisAcilisTarihi,
                //"Berat Yılı": item.BeratYili,
                "Berat Sayacı (YIL)": item.BeratSayaci,
                //"Daha Önce Alınan Beratlar": item.GecmisBerat,
                //"Aldığı Son Yıl": item.AldigiSonYil,
                //"Hak Ediş Yılı": item.HakEdisYil,
                "2014 Öncesinde Alınan Berat": item.Berat2014,
                "29.03.2015 Tarihinde Alınan Berat": item.Berat2015,
                "13.04.2019 Tarihinde Alınan Berat" : item.Berat2019,
                "01.05.2025 tarihinde Alınan Berat": item.Berat2025,
                "Berat Durumu": item.BeratDurum,
                "Berat Açıklama": item.YORUM,
                "İşlem Tarihi": item.IslemTarihi,
                "İşlem Yapan": item.IslemYapan
            })
        });
        ExcelFileCreator(exportDataReport, "YS Berat Raporu");

    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const getBolgeAdiKoduData = () => {
        axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
            setBolgeAdiKodu(response?.data);
        })

    }

    const getBirimData = (BirimKodu) => {

        if (!BirimKodu || BirimKodu.length < 1) {
            setBirimData([]);
        } else {
            setLoading(true);
            axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
                setBirimData([SelectAllOption, ...response.data]);
                setLoading(false);
            });
        }
    }
    const getBirimDataForConfirm = (BirimKodu) => {
        if (!BirimKodu || BirimKodu.length < 1) {
            setBirimData([]);
        } else {
            setLoading(true);
            axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
                setBirimDataForConfirm([SelectAllOption, ...response.data]);
                setLoading(false);
            });
        }
    }


    const renderOption = (props, option, { selected }) => (
        <li {...props}>
            <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
            />
            {option.Dsc}
        </li>
    );


    const columns = [
        { field: 'BolgeYoneticiligi', headerName: 'Bölge', width: 200 },
        { field: 'ServisKodu', headerName: 'Servis Kodu', width: 120 },
        { field: 'ServisAdi', headerName: 'Servis Adı', width: 200 },
        { field: 'ServisUnvani', headerName: 'Servis Unvanı', width: 120 },
        { field: 'Aktif', headerName: 'Aktif/Pasif', width: 120 },
        { field: 'ServisAcilisTarihi', headerName: 'Berat Referans Tarihi', width: 150 },
        //{ field: 'BeratYili', headerName: 'Berat Yılı', width: 120 },
        { field: 'BeratSayaci', headerName: 'Berat Sayacı (YIL)', width: 180 },
        //{ field: 'GecmisBerat', headerName: 'Daha Önce Alınan Beratlar', width: 330 },
        //{ field: 'AldigiSonYil', headerName: 'Aldığı Son Yıl', width: 150 },
        //{ field: 'HakEdisYil', headerName: 'Hak Ediş Yılı', width: 150 },
        { field: 'Berat2014', headerName: '2014 Öncesinde Alınan Berat', width: 120 },
        { field: 'Berat2015', headerName: '29.03.2015 Tarihinde Alınan Berat', width: 120 },
        { field: 'Berat2019', headerName: '13.04.2019 Tarihinde Alınan Berat', width: 120 },
        { field: 'Berat2025', headerName: '01.05.2025 tarihinde Alınan Berat', width: 120 },
        { field: 'BeratDurum', headerName: 'Berat Durumu', width: 150 },
        { field: 'YORUM', headerName: 'Berat Açıklama', width: 200, renderCell: renderCellExpand },
        { field: 'IslemTarihi', headerName: 'İşlem Tarihi', width: 200 },
        { field: 'IslemYapan', headerName: 'İşlem Yapan', width: 150 }
    ];

    const getReport = () => {
        if (!selectedbolgeAdiKodu || selectedbolgeAdiKodu.length < 1) {
            setresponseMessage('Lütfen bölge seçimi yapınız!...');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setLoading(true);
        setReportData([]);
        const birimKoduQuery = !SelectedBirim || SelectedBirim.length < 1 || SelectedBirim.find((x) => x.BirimKodu == 0) ? '0'
            : SelectedBirim?.map(x => x.BirimKodu).join("&BirimKodu=");
        const bolgeKoduQuery = !selectedbolgeAdiKodu || selectedbolgeAdiKodu.length < 1 || selectedbolgeAdiKodu.find((x) => x.BirimKodu == 0) ? '0'
            : selectedbolgeAdiKodu?.map(x => x.BirimKodu).join("&BolgeKodu=");
        axios.get(`GetApolloServiceBeratReport?BolgeKodu=${bolgeKoduQuery}&BirimKodu=${birimKoduQuery}`).then((response) => {
            if (response.data.length > 0) {
                var reportDataTMP = response.data;
                setReportData(reportDataTMP);
                setLoading(false);
            } else {
                setresponseMessage('Hiç data bulunamadı!...');
                setUyariTip('error');
                setUyari(true);
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });

    }





    return (
        <Page>
            <Backdrop style={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
                ></Alert>
            </Snackbar>
            <ThemeProvider theme={theme2}>
                <TabContext value={tabValue}>
                    <Box sx={{
                        paddingTop: 2,
                        borderBottom: 1,
                        borderColor: 'divider',
                        display: 'flex',
                        justifyContent: 'center',
                        //change color of tab
                        '& .MuiTab-root': {
                            '&.Mui-selected': {
                                color: '#FF9800',
                            },
                        },
                        //hange color of indicator
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#FF9800'
                        }
                    }}>
                        <TabList onChange={handleTabChange} aria-label="simple tabs example">
                            <Tab label="Yetkili Servis Berat Yönetimi" value={0} />
                            <Tab label="Yetkili Servis Berat Raporu" value={1} />
                        </TabList>
                    </Box>

                    <TabPanel value={0}>
                        <Card >
                            <CardHeader
                                title="Yetkili Servis Berat Yönetimi"
                                action={
                                    <Stack direction="row" spacing={1}>
                                        <Tooltip placement="top" title="YS referans tarihi gir">
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                setOpenReferansGir(true);          // dialogu aç
                                                }}
                                                style={{ backgroundColor: '#424242', color: 'white' }}
                                            >
                                                <EditCalendar />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip placement="top" title="Berat Hesapla">
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                setOpenBeratHesapla(true);          // dialogu aç
                                                }}
                                                style={{ backgroundColor: '#424242', color: 'white' }}
                                            >
                                                <CalendarTodayIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                }
                            />
                            <Divider />
                            <CardContent >
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 6,
                                            lg: 5
                                        }}>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="combo-box-demo"
                                            fullWidth
                                            value={selectedbolgeAdiKoduFormForConfirm}
                                            options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                                            getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                            renderOption={renderOption}
                                            onChange={(event, newValue) => {
                                                setSelectedbolgeAdiKoduFormForConfirm(newValue);
                                                var bolgeKodu = newValue?.find(x => x.BirimKodu == 0) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                                                getBirimDataForConfirm(bolgeKodu);
                                                setSelectedBirimForConfirm([]);
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                                if (bolgeAdiKodu.length > 0 && tagValue.length === bolgeAdiKodu.length) {
                                                    return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                                                }
                                                const visibleCount = 1;
                                                return (
                                                    <>
                                                        {tagValue.slice(0, visibleCount).map((option, index) => (
                                                            <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                                                        ))}
                                                        {tagValue.length > visibleCount && (
                                                            <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                                                        )}
                                                    </>
                                                );
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 6,
                                            lg: 5
                                        }}>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="combo-box-demo"
                                            fullWidth
                                            value={SelectedBirimForConfirm}
                                            options={BirimDataForConfirm.length > 0 ? BirimDataForConfirm : []}
                                            getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                            renderOption={renderOption}
                                            onChange={(event, newValue) => {
                                                newValue?.find(x => x.Id == -1) ? setSelectedBirimForConfirm(BirimDataForConfirm) : setSelectedBirimForConfirm(newValue);
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                                if (BirimDataForConfirm.length > 0 && tagValue.length === BirimDataForConfirm.length) {
                                                    return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                                                }
                                                const visibleCount = 1;
                                                return (
                                                    <>
                                                        {tagValue.slice(0, visibleCount).map((option, index) => (
                                                            <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                                                        ))}
                                                        {tagValue.length > visibleCount && (
                                                            <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                                                        )}
                                                    </>
                                                );
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            lg: 2
                                        }}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                getBeratConfirmData();
                                            }}
                                        >
                                            ARA
                                            <SearchIcon style={{ marginLeft: '5px' }} />
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
                                    <OutlinedInput
                                        id="input-search-card-style1"
                                        placeholder="Sonuçlarda ara"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                        autoComplete="off"
                                        size='small'
                                        notched
                                        sx={{
                                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#424242'
                                            },
                                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: '#FF9800'
                                            },
                                        }}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <SearchIcon stroke={1.5} size="16px" />
                                            </InputAdornment>
                                        }
                                    />
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            handleExportClick();
                                        }}
                                    >
                                        İNDİR
                                        <PrintIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Stack>
                                <TableContainer style={{ marginTop: 10 }}>
                                    <Table stickyHeader aria-label="sticky table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell >Bölge Yöneticiliği</TableCell>
                                                <TableCell >Servis Kodu</TableCell>
                                                <TableCell >Servis Adı</TableCell>
                                                <TableCell >Servis Unvanı</TableCell>
                                                <TableCell >Hesap Tarihi</TableCell>
                                                <TableCell >Berat Referans Tarihi</TableCell>
                                                {/* <TableCell>En son alınan berat</TableCell> */}
                                                <TableCell>
                                                    <span style={{ cursor: 'pointer' }} onClick={handleDurumFilterClick}>
                                                        Durum ▼
                                                    </span>
                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl)}
                                                        onClose={() => setAnchorEl(null)}
                                                    >
                                                        {durumOptions.map(opt => (
                                                            <MenuItem key={opt.value ?? 'all'} onClick={() => handleDurumFilterSelect(opt.value)}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Menu>
                                                </TableCell>
                                                <TableCell >Berat Yılı</TableCell>
                                                <TableCell >Berat Sayacı (YIL)</TableCell>
                                                <TableCell >İşlem</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : filteredData
                                            ).map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell >{row.BolgeYoneticiligi}</TableCell>
                                                    <TableCell >{row.ServisKodu}</TableCell>
                                                    <TableCell >{row.ServisAdi}</TableCell>
                                                    <TableCell >{row.ServisUnvani}</TableCell>
                                                    <TableCell >{row.HesapTarihi}</TableCell>
                                                    <TableCell >{row.ServisAcilisTarihi}</TableCell>
                                                    <TableCell >
                                                        {row.BeratDurum === 0 && <Chip label={row.ACIKLAMA} size="small" color="warning" icon={<PendingIcon />} />}
                                                        {row.BeratDurum === 1 && <Chip label={row.ACIKLAMA} size="small" color="success" icon={<DoneIcon />} />}
                                                        {row.BeratDurum === 2 && <Chip label={row.ACIKLAMA} size="small" color="error" icon={<CancelIcon />} />}
                                                    </TableCell>
                                                    <TableCell >{row.BeratYili}</TableCell>
                                                    <TableCell >{row.BeratSayaci}</TableCell>
                                                    <TableCell align="left">
                                                        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
                                                            <Tooltip placement="top" title="Berat Önizleme">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedServiceCode(row.ServisKodu);
                                                                        setSelectedServiceName(row.ServisAdi);
                                                                        setBeratYili(row.BeratYili)
                                                                        setOpenBeratPreview(true);
                                                                    }}
                                                                    style={{ backgroundColor: '#FF9800', color: 'white' }}
                                                                >
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </Tooltip>

                                                            {(
                                                                row.Preview === 0 && 
                                                                ( (SessionUser.Role_Id === 1 || SessionUser.Role_Id === 3) ||
                                                                    (SessionUser.Role_Id === 8 && 
                                                                    SessionUser.TopServiceShopName === row.BolgeYoneticiligi)
                                                                )                  
                                                             ) &&<Tooltip placement="top" title="Berat Onay İşlemi">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setBeratComment('');
                                                                        setSelectedEmployeeBerat(row);
                                                                        setOpenBeratConfirm(true);
                                                                    }}
                                                                    style={{ backgroundColor: '#FF9800', color: 'white' }}
                                                                >
                                                                    <DoneAllIcon />
                                                                </IconButton>
                                                            </Tooltip>}
                                                            {row.Preview === 0 && <Tooltip placement="top" title="Belge Ekle">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedEmployeeBerat(row);
                                                                        setOpenBeratUpload(true);
                                                                    }}
                                                                    style={{ backgroundColor: '#FF9800', color: 'white' }}
                                                                >
                                                                    <CloudUploadIcon />
                                                                </IconButton>
                                                            </Tooltip>}
                                                            
                                                        </Stack>
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, { label: 'Tümü', value: -1 }]}
                                        component="div"
                                        count={filteredData.length}
                                        labelRowsPerPage={"Sayfa başına satır:"}
                                        labelDisplayedRows={({ from, to, count }) => `${count} kayıttan ${from} - ${to} arasındaki kayıtlar gösteriliyor`}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </TabPanel>
                    <TabPanel value={1}>
                        <Card >
                            <CardHeader title="Yetkili Servis Berat Raporu" />
                            <Divider />
                            <CardContent >
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 6,
                                            lg: 5
                                        }}>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="combo-box-demo"
                                            fullWidth
                                            value={selectedbolgeAdiKodu}
                                            options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                                            getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                            renderOption={renderOption}
                                            onChange={(event, newValue) => {
                                                setSelectedbolgeAdiKodu(newValue);
                                                var bolgeKodu = newValue?.find(x => x.BirimKodu == 0) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                                                getBirimData(bolgeKodu);
                                                setSelectedBirim([])
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                                if (bolgeAdiKodu.length > 0 && tagValue.length === bolgeAdiKodu.length) {
                                                    return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                                                }
                                                const visibleCount = 1;
                                                return (
                                                    <>
                                                        {tagValue.slice(0, visibleCount).map((option, index) => (
                                                            <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                                                        ))}
                                                        {tagValue.length > visibleCount && (
                                                            <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                                                        )}
                                                    </>
                                                );
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 6,
                                            lg: 5
                                        }}>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="combo-box-demo"
                                            fullWidth
                                            value={SelectedBirim}
                                            options={BirimData.length > 0 ? BirimData : []}
                                            getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                            renderOption={renderOption}
                                            onChange={(event, newValue) => {
                                                newValue?.find(x => x.Id == -1) ? setSelectedBirim(BirimData) : setSelectedBirim(newValue);
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                                if (BirimData.length > 0 && tagValue.length === BirimData.length) {
                                                    return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                                                }
                                                const visibleCount = 1;
                                                return (
                                                    <>
                                                        {tagValue.slice(0, visibleCount).map((option, index) => (
                                                            <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                                                        ))}
                                                        {tagValue.length > visibleCount && (
                                                            <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                                                        )}
                                                    </>
                                                );
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            lg: 2
                                        }}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                getReport();
                                            }}
                                        >
                                            ARA
                                            <SearchIcon style={{ marginLeft: '5px' }} />
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            handleExportClickReport();
                                        }}
                                    >
                                        İNDİR
                                        <PrintIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Stack>
                                <div style={{ minHeight: 300, width: '100%', marginTop: 10 }}>
                                    <DataGrid
                                        rows={reportData}
                                        columns={columns}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 5 },
                                            },
                                        }}
                                        pageSizeOptions={[5, 10]}
                                        getRowId={(row) => row.Id}
                                        localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
                                        sx={styles.root}
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    </TabPanel>
                </TabContext>
            </ThemeProvider>

            <BeratDocumentUploadDialog
               open={openBeratUpload}
               onClose={() => setOpenBeratUpload(false)}
               birimKodu={selectedEmployeeBerat.ServisKodu}
           />
            <BeratHesaplaDialog
                open={openBeratHesapla}
                onClose={() => setOpenBeratHesapla(false)}
                onPreview={(data) => setBeratData(data)}
            />
            <ReferansTarihiDialog
                open={openReferansGir}
                onClose={() => setOpenReferansGir(false)}
                backdropSx={styles.backdrop}
            />
            <Dialog
                open={openBeratConfirm}
                fullWidth
                maxWidth="sm"
                onClose={() => setOpenBeratConfirm(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    id="alert-dialog-title"
                    style={{ textAlign: 'center' }}
                >
                </DialogTitle>
                <Container maxWidth="sm" spacing={1}>
                    <IconButton
                        onClick={() => {
                            setOpenBeratConfirm(false);
                        }}
                        aria-label="close"
                        sx={styles.closeButton}
                        component="span"
                        variant="contained"
                        edge="start"
                        color="inherit"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Divider />
                    <Card>
                        <CardHeader title={'Onayla & Reddet'} />
                        <Divider />
                        <CardContent style={styles.cardscontent}>
                            <Grid container spacing={2}>
                                {selectedEmployeeBerat.YORUM && selectedEmployeeBerat.YORUM.length > 0 && (
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            lg: 12
                                        }}>
                                        <MuiAlert severity="info">
                                            <b>Önceki Yorum - {selectedEmployeeBerat.YORUM}  ({selectedEmployeeBerat.ONAYLAMA_TARIHI})</b>
                                            <br />
                                            <b style={{ fontWeight: 450 }}>
                                                {selectedEmployeeBerat.ONAYLAYAN} - {selectedEmployeeBerat.ONAYLAYAN_AD_SOYAD}:&nbsp;
                                            </b>
                                            {selectedEmployeeBerat.YORUM}
                                        </MuiAlert>
                                    </Grid>)}
                                
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        lg: 12
                                    }}>
                                    <TextField
                                        size="small"
                                        id="desc"
                                        autoComplete="no"
                                        multiline
                                        error={required}
                                        helperText={beratCommentError}
                                        rows={10}
                                        value={beratComment}
                                        onChange={(event) => setBeratComment(
                                            event.target.value
                                        )}
                                        fullWidth
                                        label='Yorum'
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Divider />
                </Container>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => handleBeratOperation(2)}
                        aria-label="close"
                        component="span"
                        variant="contained"
                        endIcon={<BlockIcon />}
                        style={{ backgroundColor: '#ff0000', color: 'white' }}
                    >
                        Reddet
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => handleBeratOperation(1)}
                        aria-label="save"
                        component="span"
                        variant="contained"
                        style={{ backgroundColor: '#008000', color: 'white' }}
                        endIcon={<CheckCircleOutlineIcon />}
                    >
                        Onayla
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openBeratPreview}
                onClose={() => setOpenBeratPreview(false)}
                PaperProps={{ style: styles.dialogPaper }}
                maxWidth="80%"
            >
                <DialogTitle>
                    <Button
                        style={{ ...styles.action, marginRight: '5px' }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            handleDownloadImage();
                        }}
                    >
                        İNDİR
                        <PrintIcon style={{ marginLeft: '5px' }} />
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12
                        }}>

                        <div style={{ margin: 0 }}>
                            <div id="p1" ref={svgRef} style={containerStyle}>
                                <svg width="1286" height="909" xmlns="http://www.w3.org/2000/svg">
                                    {/* Render the SVG image */}
                                    <image href={beratSvg} width="1286" height="909" />
                                    {/* Render the text elements */}
                                    <text x="650" y="210" style={textStyle1} textAnchor="middle">
                                        {selectedServiceName.charAt(0).toLocaleUpperCase('tr-TR') + selectedServiceName.slice(1).toLocaleLowerCase('tr-TR')}

                                    </text>
                                    <text x="650" y="290" style={textStyle1} textAnchor="middle">
                                        Yetkili Servisi
                                    </text>

                                    {/* <text x={textStyle1X} y="370" style={textStyle1}>
                                    </text> */}
                                    <text x="310" y="420" style={textStyle2}>
                                        Yetkili servisimiz olarak {beratYili} yıl kalitenin, hizmetin ve başarının 
                                    </text>
                                    <text x="300" y="450" style={textStyle2}>
                                        saygın bir temsilcisi oldunuz. Bu özverili çalışmalarınız için takdir 
                                    </text>
                                    <text x="300" y="480" style={textStyle2}>
                                         ve teşekkürlerimizi sunarız.  
                                    </text>
                                    <text x="300" y="540" style={textStyle2}>
                                        Saygılarımızla,  
                                    </text>
                                    <text x="500" y="660" style={textStyle3}>
                                        Arçelik Pazarlama A.Ş.
                                    </text>
                                    <text x="440" y="690" style={textStyle3}>
                                        Müşteri Hizmetleri Direktörlüğü
                                    </text>
                                    <image href={ArcelikImg} x="420" y="740" />
                                    <image href={BekoImg} x="760" y="740" />
                                </svg>
                            </div>
                        </div>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenBeratPreview(false)} color="primary">
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog>
        </Page >
    );
};

export default YSBeratManagement;
